import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-info">
            <h3>JW Salon</h3>
            <p>Boutique Hair Studio</p>
          </div>
          <div className="social-media">
            {/* <a href="https://instagram.com" className="social-icon" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </a> */}
            {/* <a href="https://facebook.com" className="social-icon" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook"></i>
            </a> */}
            {/* <a href="https://www.xiaohongshu.com" className="social-icon" aria-label="Little Red Book" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-pinterest"></i>
            </a> */}
            <a
              href="weixin://contacts/profile/wxid_chf1ew488kf612D"
              className="social-icon"
              aria-label="WeChat"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-weixin"></i>
            </a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 JW Salon. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;



